import { Card, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { AuthGuard, EmptyState, GenericHeader, MonoText, Page, MoneyDisplay } from 'components';
import React from 'react';
import { useSelector } from 'react-redux';
import Currency from "utils/currency";
import { ecommerce_manager } from 'utils/constants';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  },
  content: {
    padding: 0,
  },
}));

const OrderItems = props => {
  const model = useSelector(state => state.models.order);
  const classes = useStyles();

  const models = model.orderitems;

  const Head = props => {
    let { handleCreateOpen, ...rest } = props; // eslint-disable-line
    return (
      <GenericHeader header="Order Items" subheader="Order Details" {...rest} />
    );
  }

  return (
    <AuthGuard roles={[ecommerce_manager]} projects={[]}>
      <Page className={classes.root} title="Order Items">
        <Head />
        <Card>
          <CardHeader title="Order Items" />
          <Divider />
          <CardContent className={classes.content}>
            <div className={classes.inner}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>SKU</TableCell>
                    <TableCell>Code</TableCell>
                    <TableCell>Quantity</TableCell>
                    <TableCell>Unit Price</TableCell>
                    <TableCell>Subtotal</TableCell>
                    {/* <TableCell align="right">Actions</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {models.map(item => (
                    <TableRow hover key={item.id}>
                      <TableCell>
                        <div>{item.name_en}</div>
                        <div><Typography variant="caption">{item.reference}</Typography></div>
                      </TableCell>
                      <TableCell>
                        <MonoText>{item.sku}</MonoText>
                      </TableCell>
                      <TableCell>
                        <MonoText>{item.code}</MonoText>
                      </TableCell>
                      <TableCell>
                        <MonoText>{item.quantity}</MonoText>
                      </TableCell>
                      <TableCell>
                        <MonoText><MoneyDisplay amount={item.unit_price} currency={model.currency} /></MonoText>
                      </TableCell>
                      <TableCell>
                        <MonoText><MoneyDisplay amount={item.subtotal} currency={model.currency} /></MonoText>
                      </TableCell>
                      {/* <TableCell align="right">
                        <Button color="primary" component={RouterLink} size="small" to={`/orders/${item.id}/summary`} variant="outlined">
                          View
                          </Button>
                      </TableCell> */}
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell colSpan="5" align="right">Subtotal: </TableCell>
                    <TableCell>{Currency.compress(model.subtotal, model.currency)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan="5" align="right">Shipping: </TableCell>
                    <TableCell>{Currency.compress(model.shipping, model.currency)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan="5" align="right">Discount:</TableCell>
                    <TableCell>{Currency.compress(model.discount, model.currency)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan="5" align="right">Total:</TableCell>
                    <TableCell><MoneyDisplay amount={model.total} currency={model.currency} /></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </div>
          </CardContent>
          <EmptyState active={!models.length} />
        </Card>
      </Page>
    </AuthGuard>
  );
};

export default OrderItems;
